<template>
  <div class="store-card">
    <div class="wrap flex-col">
      <div class="layer flex-row">
        <img
          alt=""
          class="img"
          referrerpolicy="no-referrer"
          :src="
            profile.storeLogo
          "
        />
        <div class="section1 flex-col">
          <div class="word1">
            <div
              :style="{
                width: isShowType ? '110px' : '100%',
              }"
            >
              {{ profile.storeName }}
            </div>
            <span v-if="isShowType">{{ profile.chargeStandardType }}</span>
          </div>
          <span class="word2">{{
              profile.plazaName + '' + profile.floor
            }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getStoreInfo } from '@/api';

export default {
  name: 'StoreCard',

  mixins: [],

  components: {
  },

  props: {
    name: {
      type: String,
      default: '',
    },
    des: {
      type: String,
      default: '',
    },
    info: {
      type: Object,
      default: () => {},
    },
    isShowType: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      profile: {},
    };
  },

  computed: {},

  watch: {
    'info.storeCode'(id) {
      if (id) this.getStoreInfo();
    },
  },

  created() {},

  mounted() {
    if (this.info.storeCode) this.getStoreInfo();
  },

  destroyed() {},

  methods: {
    async getStoreInfo() {
      this.profile = Object.freeze(await getStoreInfo(this.info));
    },
  },
};
</script>

<style lang="less" scoped>
.store-card {
  width: 100%;
  .wrap {
    align-self: center;
    width: 100%;
    height: 104px;
    justify-content: center;
    align-items: flex-start;
    box-sizing: border-box;
  }

  .layer {
    width: 227px;
    height: 64px;
    justify-content: space-between;
  }

  .img {
    width: 64px;
    height: 64px;
  }

  .section1 {
    width: 100%;
    margin-top: 5px;
    margin-left: 15px;
  }

  .word1 {
    display: flex;
    justify-content: space-between;
    width: 100%;
    overflow-wrap: break-word;
    color: rgba(102, 102, 102, 1);
    font-size: 16px;
    font-family: PingFangSC-Regular, serif;
    white-space: nowrap;
    line-height: 22px;
    text-align: left;
    align-self: flex-start;
    & > div {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .word2 {
    width: 100%;
    display: block;
    overflow-wrap: break-word;
    color: rgba(153, 153, 153, 1);
    font-size: 14px;
    font-family: PingFangSC-Regular, serif;
    line-height: 20px;
    text-align: left;
    margin-top: 12px;
    word-break: break-all;
  }
}
</style>
